import { render, staticRenderFns } from "./companyHistory.vue?vue&type=template&id=62f2a297&scoped=true&"
import script from "./companyHistory.vue?vue&type=script&lang=js&"
export * from "./companyHistory.vue?vue&type=script&lang=js&"
import style0 from "./companyHistory.vue?vue&type=style&index=0&id=62f2a297&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f2a297",
  null
  
)

export default component.exports